export const lorawanthreadtypeData = [
    { name: "Chirpstack", id: 'chirpstack' },
    { name: "Wiotys", id: 'wiotys' },
]